var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666564",
    fillRule: "evenodd",
    d: "M9.987 6.102l-4.681 4.681-.22 2.464 2.48-.226 4.667-4.672-2.246-2.247zm4.986-.495l-2.246-2.245-1.624 1.624 2.246 2.246 1.623-1.625zm-10.73 9.39c-.026.002-.05.003-.076.003-.22 0-.432-.087-.589-.244-.175-.175-.263-.419-.24-.664l.315-3.476c.035-.381.204-.74.474-1.011l7.497-7.498c.585-.586 1.647-.557 2.263.059l2.282 2.281h.001c.638.64.663 1.654.057 2.262l-7.498 7.498c-.27.271-.629.439-1.01.474l-3.476.316zm-.076 1.67h11.667c.458 0 .833.375.833.833 0 .458-.375.833-.833.833H4.167c-.458 0-.833-.375-.833-.833 0-.458.375-.833.833-.833z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_edit.ad0d9743.svg";
export { ForwardRef as ReactComponent };